export const reasonsMessages = {
  create: 'Tạo mới lý do',
  update: 'Cập nhật lý do',
  code: 'Mã lý do',
  content: 'Nội dung lý do',
  delete: 'Xóa lý do bận',
  confirmDelete: 'Bạn có chắc chắn muốn xóa lý do bận này không?'
};
